export const CREATE_CHARGE_BATCH = 'app/CREATE_CHARGE_BATCH';
export const CREATE_CHARGE_BATCH_SUCCESS = 'app/CREATE_CHARGE_BATCH_SUCCESS';
export const CREATE_CHARGE_BATCH_FAILURE = 'app/CREATE_CHARGE_BATCH_FAILURE';

export const FORM_NAME = 'CreateChargeBatch';
